import { render } from "./AvatarUploadSelf.vue?vue&type=template&id=1b11a794&ts=true"
import script from "./AvatarUploadSelf.vue?vue&type=script&lang=ts"
export * from "./AvatarUploadSelf.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__